import { render, staticRenderFns } from "./LastResult.vue?vue&type=template&id=7bdc0a24"
import script from "./LastResult.vue?vue&type=script&lang=js"
export * from "./LastResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports